var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStationUserChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4984 16.7491L13.7651 18.0158L16.2984 15.4824M10.5968 9.93158C10.5134 9.92325 10.4134 9.92325 10.3218 9.93158C9.36528 9.89911 8.45898 9.49561 7.7948 8.80655C7.13062 8.11749 6.76073 7.19696 6.76344 6.23992C6.76213 5.75436 6.85666 5.27331 7.04161 4.82436C7.22657 4.3754 7.49831 3.96737 7.84126 3.62364C8.18422 3.27991 8.59164 3.00724 9.04018 2.82128C9.48872 2.63531 9.96955 2.5397 10.4551 2.53992C12.4968 2.53992 14.1551 4.19825 14.1551 6.23992C14.1551 8.23992 12.5718 9.86492 10.5968 9.93158Z",
    stroke: "#32D583",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4559 19.0482C8.93927 19.0482 7.43093 18.6649 6.28093 17.8982C4.26427 16.5482 4.26427 14.3482 6.28093 13.0066C8.5726 11.4732 12.3309 11.4732 14.6226 13.0066",
    stroke: "#1D2939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationUserChecked);
export default __webpack_public_path__ + "static/media/station_user_checked.da96fcf5f2ec07d2b578df68b3511ffd.svg";
export { ForwardRef as ReactComponent };